export function getIntercomUserID(appName: string, email: string): string {
  const appSlug = appName.replace(/ /g, '-');
  return `${appSlug}-${email}`;
}
